<template>
  <div>
    <!--Round Robin offer-->
    <div class="msg info interRelated" v-if="currentBetSlipState==0 && activeSelectionsNo>=3 && interRelatedLen && !allowedBetTypesRR.length && !gettingABTnR">
      <icon name="icon-information" colorName="blue"></icon>
      {{ $t('BetSlip.tab.RR.info.interRelated') }}
    </div>

    <div v-if="currentBetSlipState<1 && (activeSelectionsNo<3) && !gettingABTnR" class="empty-betslip msg info">
      <icon name="icon-information" colorName="blue"></icon>
      <span v-html="$t('BetSlip.tab.RR.emptyInfoMsg')"></span>
    </div>
    <div >
      <div class="allowedRR">
        <div v-for="(betType, index) in allowedBetTypesRR" class="itemRR betType" :class="{first:index==0, last: index+1==allowedBetTypesRR.length}"
           v-show="currentBetSlipState<1 || betTypeStakes[betType.IDFOBetType]">

          <bet-type-rr
            :bt="betType"
            :stake="betTypeStakes[betType.IDFOBetType]"
            :parlayTeamsNo="parlayTeamsNo"
            :allowedBetTypesAndReturns="allowedBetTypesAndReturns"
            :gettingABTnR="gettingABTnR"
            :currentBetSlipState="currentBetSlipState"
          ></bet-type-rr>
        </div>

        <!-- Should PARLAY be displayed ? -->
        <div v-for="(betType, index) in allowedBetTypesPRL" class="itemRR betType parlay"  :class="{first:index==0, last: index+1==allowedBetTypesPRL.length}"
          v-show="activeSelectionsNo>1 && (currentBetSlipState<1 || betTypeStakes[betType.IDFOBetType])">

          <bet-type-parlay
            :bt="betType"
            :stake="betTypeStakes[betType.IDFOBetType]"
            :parlayTeamsNo="parlayTeamsNo"
            :allowedBetTypesAndReturns="allowedBetTypesAndReturns"
            :gettingABTnR="gettingABTnR"
            :currentBetSlipState="currentBetSlipState"
          ></bet-type-parlay>
        </div>
      </div>
    </div>
    <!--activeRR: {{activeRR}}<br>-->
    <!--winnings: {{winnings}}<br>-->
    <!--betTypeStakes: {{betTypeStakes}}<br>-->
    <!--allowedBetTypesAndReturns: {{allowedBetTypesAndReturns}}<hr>-->
    <!--<br>selectedObj: {{selectedObj}}<hr>-->
    <!--<br>allowedBetTypesPRL: {{allowedBetTypesPRL}}<hr>-->
    <!--interRelated: {{interRelated}}<br>-->
    <!--interRelatedActive: {{interRelatedActive}}<br>-->
    <!--interRelatedLen: {{interRelatedLen}}<br>-->
  </div>
</template>

<script>
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import stakeAndReturn from './stakeNreturn.vue'
  import Icon from '@/components/common/Icon'
  import betTypeParlay from './betTypeParlayRR'
  import betTypeRr from './betTypeRR'

  export default {
    name: 'TeaserTab',

    props: ['betsNo', 'betslipSelections', 'allowedBetTypesAndReturns', 'allowedBetTypesRR', 'allowedBetTypesPRL', 'activeRR', 'currentBetSlipState', 'gettingABTnR', 'betTypeStakes', 'winnings'],

    components: {
      priceFormat,
      stakeAndReturn,
      Icon,
      betTypeParlay,
      betTypeRr
    },

    data () {
      return {
        RRdetails: null
      }
    },

    computed: {
      placeholder () {
        return {
          wager: this.$t('BetSlip.input.placeholder.wager'),
          return: this.$t('BetSlip.input.placeholder.return')
        }
      },
      selectedObj: {
        // getter
        get: function () {
          return store.getters['sbBetslipState/optedInRR']
        },
        // setter
        set: function (newValue) {
//          console.log('selected newValue: ' + newValue)
        }
      },
      activeSelectionsNo () {
        var c = 0
        for (var i in this.selectedObj) {
          c += this.selectedObj[i] ? 1 : 0
        }
        return c
      },
      interRelated () {
        return store.getters['sbBetslipState/interRelated']
      },
      interRelatedActive () {
        var self = this
        return Object.keys(this.interRelated).filter(function (s) {
          return self.selectedObj[s]
        })
      },
      interRelatedLen () {
        var self = this
        var no = 0
        var ir = {}
        this.interRelatedActive.forEach(function (s) {
          var i = self.interRelated[s]
          if (i) {
            ir[i] = ir[i] || 0
            ir[i]++
          }
        })
        for (var j in ir) {
          if (ir[j] > 1) {
            no = ir[j]
          }
        }
        return no
      }
    },

    methods: {
      parlayTeamsNo (id) {
        // var str = this.allowedBetTypesAndReturns.PotentialReturns.PerBetType[id].CalculatedUnits
        // return str.split(';')[0].split(')')[0].split('(')[1].split(',').length
        var selections = store.getters['sbBetslipState/betslipSelections']
        var c = (selections && selections.length) || 0
        if (this.selectedObj) {
          c = 0
          for (var i in this.selectedObj) {
            if (this.selectedObj[i]) {
              c++
            }
          }
        }
        return c
      },
      getSelectionDataById (id) {
        var selection = store.getters['sbBetslipState/getSelectionById'](id)
        var market = store.getters['sbBetslipState/getMarketById'](id)
//        console.log(selection)
        return [{selection: selection, market: market}]
      },
      formatOdds (betType) {
        var odds = betType.PotentialReturn - betType.UnitCount + 1
        var formatted = priceFormat.formatOdds(odds, -1)
        return formatted
      },
      formatHandicap (selection) {
        var h = selection && (selection.currenthandicap || selection.currentmatchhandicap)
        h = h && !isNaN(h) ? parseFloat(h) : ''
        if (h) {
          if (selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h) {
              h *= -1
            }
          }
          if (selection.hadvalue === 'H' || selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h > 0) {
              h = '+' + h
            }
          }
        }
        return h
      },
      formatSelectionName (selection) {
        return Array.isArray(selection.name) ? selection.name[0] : selection.name
      },
      formatSelectionPrice (selection) {
        return priceFormat.formatSelectionPrice(selection)
      },
      setActiveRR (newValue) {
//        console.log('setActiveRR')
        this.activeRR.IDFOBetType = newValue
        this.activeRR.UnitCount = this.allowedBetTypesAndReturns.PotentialReturns.PerBetType[newValue].UnitCount
        this.activeRR.PotentialReturn = this.allowedBetTypesAndReturns.PotentialReturns.PerBetType[newValue].PotentialReturn
      },
      toggleRRdetails (betType) {
        this.RRdetails = this.RRdetails === betType ? false : betType
      },
      updateSelected () {
//        console.log('updateSelected')
        this.$emit('updateSelected', false)
        store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
      }
    },

    created () {
//      console.log('Created RR')
//      store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
    }
  }
</script>

<style lang="stylus" scoped>
  .xWagers
    color: #818e95
    font-size: 12px
    font-weight: normal

  .betType
    background-color: #F0F3F8;
    border: 1px solid #CCC;
    padding: 0px;
    margin-top: -1px
    >>>.money-input
      background: #ffffff
    .title-parlay
      font-weight: bold;
      padding: 5px;
      color: #000;
      border: 0px solid #CCC;
      border-radius: 5px 5px 0 0;
    .stake-n-return
      padding: 5px 6px 5px
      border-radius: 0 0 5px 5px;

  .betType.last
    border-radius: 0 0 5px 5px !important

  .betType.parlay
    border-radius: 5px !important
    margin: 10px 0


  .align-center {
    text-align: center;
  }

  .btn-container {
    background-color: #999;
  }

  .btn {
    min-width: 80%;
    min-height: 40px;
    text-transform: none;
    padding: 5px;
    height: auto;
  }


  .RR {
    .optedOut {
      background-color: #e0e0e0;
      color: gray;
    }

    .win-line {
      background-color: #9e864d;
      color: white;
      padding: 5px;
    }

    .total-stake-line {
      background-color: #CCC;
      color: black;
    }

  .odds-line,
  .total-stake-line,
  .win-line {
    clear: both;
    padding: 5px 5px;
    text-align: right;

    .label {
      float: left;
    }
    input {
      background-color: white;
      text-align: right;
    }

  }

    .odds {
      color: #0F89F1;
    }


    input {
      width: 80px;
    }

    .itemRR {
      // margin-bottom: 5px;
      .header-RR {
        font-weight: bold;
        padding: 10px 12px 0;
        font-size: 14px
      }
    }

    .allowedRR {
      margin-bottom: 5px;
      .RRradio {
        padding: 5px;
      }

      .showRRdetails {
        float: right;
        .btnToggle {
          min-width: 20px;
          cursor: pointer;
          text-align: center;
          font-weight: bold;
        }
      }

      .RRdetails {

        text-align: center;
        div {
          border-bottom: 1px solid #CCC;
        }
        .details-header {
          background-color: #DDD;
        }
        .details-data {
          background-color: #EEE;
        }
        .selections, .odds, .win {
          display: inline-block;
          width: 32%;
          padding: 2px 5px;
        }
        .selections {
          text-align: left;
        }
        .odds {
          text-align: center;
        }
        .win {
          text-align: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/RoundRobinTab.vue